export default __webpack_public_path__ + "static/media/giglinked_i-am-musician-2.fade1a81.png";